import React, { useState, useEffect } from "react";
import _ from "lodash";
import Socket from "socket";
import checkIcon from "assets/images/say-what/check.png";
import logo from "assets/images/say-what/saywhat-logo.png";
import uncheckIcon from "assets/images/say-what/uncheck.png";

const BeforeVoting = ({
  photo,
  roomId,
  cc_vote,
  captions,
  mobile_app,
  set_cc_vote,
  currentPlayer,
  voting_params
}) => {
  const top_text = _.get(voting_params, "top_text", "Vote for one!");
  const ready_button = _.get(voting_params, "ready_button", "READY");
  const cant_text = _.get(voting_params, "cant_text", "(Can't Pick Your Own)");

  const [captionsArr, setCaptionsArr] = useState(
    captions.map((obj) => ({ ...obj, active: false }))
  );

  useEffect(() => {
    if (cc_vote) {
      let array = [...captionsArr];
      array.map((item, index) => cc_vote === index && (item.active = true));
    }
  }, []);

  const handleCaptionClick = (captionIndex, id) => {
    let array = [...captionsArr];
    if (currentPlayer.player_id !== id) {
      set_cc_vote(captionIndex);
      array.map((item, index) =>
        index === captionIndex ? (item.active = true) : (item.active = false)
      );
    }
    setCaptionsArr(array);
  };

  const handleVoteSubmit = () => {
    if (mobile_app) {
      const message = {
        action: "submit-vote",
        playerId: currentPlayer.player_id,
        vote: cc_vote
      };
      window.parent.postMessage(message, "*");
    } else {
      const data = {
        action: "submit-vote",
        roomId,
        playerId: currentPlayer.player_id,
        vote: cc_vote
      };
      Socket.sendMessage(data);
    }
    setTimeout(() => {
      set_cc_vote(null);
    }, 2000);
  };
  return (
    <div className={`vote ${mobile_app ? "mobile-cnt" : "web-cnt"}`}>
      <div className="vote-div">
        <img src={logo} className="sw-logo" alt="logo" />
        <br />
        <img src={photo} className="vote-img" alt="logo" />
        <p className="vote-txt">{top_text}</p>
        <div
          className={`vote-list-wrap web-cnt ${mobile_app ? "iphone6" : ""}`}
        >
          {captionsArr.map((item, index) => (
            <div
              key={item.player_id}
              className={`${item.active ? "vote-card active" : "vote-card"}`}
              onClick={() => handleCaptionClick(index, item.player_id)}
            >
              <img
                src={item.active ? checkIcon : uncheckIcon}
                className={`${
                  currentPlayer.player_id === item.player_id
                    ? "icon-disabled"
                    : "icon"
                }`}
                alt=""
              />
              <div className="cant-pick">
                <p className={`${item.active ? "txt active" : "txt"}`}>
                  {item.caption}
                </p>
                {currentPlayer.player_id === item.player_id && (
                  <p className="cant-txt">{cant_text}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      <button
        onClick={handleVoteSubmit}
        disabled={captionsArr.some((item) => item.active) ? false : true}
        className={`${
          captionsArr.some((item) => item.active) ? "ready-btn" : "disabled-btn"
        }`}
      >
        {ready_button}
      </button>
    </div>
  );
};

export default BeforeVoting;
